<template>
    <div id="login">
        <div class="pane login-form">
            <InstallLoginForm v-if="isInstalledClient" />
            <EmailLoginForm v-else />
        </div>
        <div id="login-terms">
            By signing in, you agree to our
            <a href="https://app.termly.io/policy-viewer/policy.html?policyUUID=e8482c32-22e5-414b-bafa-f8215327847d" target="_blank">Terms of Use</a>
            and
            <a href="https://app.termly.io/policy-viewer/policy.html?policyUUID=3aa9812c-cb8e-4f20-b3df-128bb3d5122b" target="_blank"
                >Privacy Policy</a
            >.
        </div>
    </div>
</template>

<script lang="ts" setup>
import { showWait } from '@signal24/vue-foundation';
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';

import { GlobalState } from '@/global';
import { useIdleUpdateNotifier } from '@/shared/helpers/update.helpers';
import { Auth } from '@/shared/services/auth.service';

import { DesktopBridge } from '../desktop/helpers/bridge';
import { PusherService } from './exports/pusher';
import EmailLoginForm from './login/f-email-login-form.vue';
import InstallLoginForm from './login/f-install-login-form.vue';

const isInstalledClient = DesktopBridge.isWithinZynoDesktop();
const router = useRouter();

onMounted(() => {
    PusherService.disconnect();

    if (router.currentRoute.value.name === 'logout') {
        return Auth.clearUserSessionAndLogin({ router, intendedUrl: '/' });
    }

    if (GlobalState.user.value) {
        const intendedUrl = String(router.currentRoute.value.query.intendedUrl ?? '/');
        router.replace(intendedUrl);
    }
});

useIdleUpdateNotifier(5_000, () => {
    console.log('Reloading ZynoSuite for update');
    showWait('Updating ZynoSuite...');
    window.location.reload();
});
</script>

<style lang="scss" scoped>
#login {
    @apply flex-1 flex items-center justify-center;
}

#login-terms {
    @apply absolute bottom-12 text-sm mt-4 text-slate-500;

    a {
        @apply text-sm text-slate-400;
    }
}
</style>
